import { DetailsEditor } from "uikit"
import FaqLinks from "components/FaqLinks"
import React, { useEffect } from "react"
import { useStore } from "store"
import { goalTypes } from "../goalTypes"
import { goalWorksheets } from "./worksheetTypes"

const GoalDetailsView = props => {
  const { household, scenario, success, type, baseUrl, goalId, isNew } = props
  useEffect(() => {
    window.trackEvent("edit-goal", { type })
  }, [type])

  const Worksheet = goalWorksheets[goalTypes[type].worksheetType]
  const iconImage = goalTypes[type].icon

  const [{ description, label, faqs = [] }] = useStore(
    "contextuals",
    `Goal: ${type}`
  )

  const faqLinks = faqs.length ? <FaqLinks items={faqs} /> : null
  function editor(goal) {
    return (
      <DetailsEditor
        iconImage={iconImage}
        heading={label}
        description={description}
        supplement={faqLinks}
      >
        <Worksheet
          household={household}
          goal={goal}
          scenario={scenario}
          success={success}
          baseUrl={baseUrl}
          isNew={isNew}
        />
      </DetailsEditor>
    )
  }

  if (isNew) {
    return editor(null)
  }

  return <GoalDetailsEditor goalId={goalId} editor={editor} />
}

const GoalDetailsEditor = props => {
  const [goal] = useStore("goals", props.goalId)
  return props.editor(goal)
}

export default GoalDetailsView
